import React from 'react';
import { connect } from 'react-redux';
import FooterSectionView from './footer-section-view';
import {
  createSectionLinkT,
  removeFooterSectionT,
  removeSectionLinkT,
  setLinkTitleT, setLinkUriT,
  setSectionLinksT,
  setSectionTitleT
} from "../../../../../state/actions/shared/section";

const FooterSectionRedux = (props) => (
  <FooterSectionView {...props}/>
);

const mapStateToProps = (state, ownProps) => {
  const { id, index } = ownProps;
  const {  title, links } = state.landingPages.landingPage.sections?.[id];

  return {
    index,
    title,
    links: links || [],
    id,
    readOnly: state.versions.readOnly,
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const {entityId, id:sectionId} = ownProps;
  const defaultLink = {title: '', uri: ''};
  return {
    onDeleteSection: () => dispatch(removeFooterSectionT('landing_page', entityId, sectionId)),
    onTitleChange: (text) => dispatch(setSectionTitleT('landing_page', sectionId, text)),
    onAddLink: () => dispatch(createSectionLinkT('landing_page', sectionId, defaultLink)),
    onLinkTitleChange: (linkId, text) => dispatch(setLinkTitleT('landing_page', sectionId, linkId, text)),
    onLinkUriChange : (linkId, text) => dispatch(setLinkUriT('landing_page', sectionId, linkId, text)),
    onLinkOrderChange: (list) => dispatch(setSectionLinksT('landing_page', sectionId, list)),
    onDeleteLink: (linkId) => dispatch(removeSectionLinkT('landing_page', sectionId, linkId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterSectionRedux);
